module.exports = __webpack_public_path__ + "static/media/unity-logo.bcbbeb5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/unity-logo.png
// module id = 499
// module chunks = 0